import React, { useState } from "react";
import { Table, Button, App, Popconfirm, Select } from "antd";
import dayjs from "dayjs";
import commaNumber from "comma-number";
import { formatDateOnly } from "../../../lib/functions";
import { DeleteOutlined, EyeOutlined } from "@ant-design/icons";
import { deleteCheque, fetchChequeList, updateChequeExpectedBank } from "../chequesThunk";
import { useDispatch, useSelector } from "react-redux";
import { useIsAdminUser } from "../../../lib/accessList";
import { useTxLock } from "../../../hooks/useTxLock";

const format = commaNumber.bindWith(",", ".");

const ChequesTable = ({ list, loading, printMode = false, onUpdate, onView, accounts = [], accountsLoading = false }) => {
  const [pageSize, setPageSize] = useState(10);
  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState(1);
  const { modal } = App.useApp();
  const isAdminUser = useIsAdminUser();
   const authInfo = useSelector((state) => state.auth?.auth_info);

  const canEdit = authInfo?.can_edit === 1;
  const canDelete = authInfo?.can_delete === 1;
const { isLocked: isTxLocked, lockDateFormatted } = useTxLock();
  const handleExpectedBankChange = async (cheque, expected_bank_acc_id) => {
    try {
      await dispatch(
        updateChequeExpectedBank({ chequeId: cheque.id, expected_bank_acc_id })
      ).unwrap();
    } catch (error) {
      modal.warning({
        title: error.error || error.message || "Failed to update Expected Bank",
      });
    }
  };

  const handleDelete = async (cheque) => {
    try {
      await dispatch(deleteCheque(cheque)).unwrap();
      modal.success({
        title: "Cheque deleted successfully",
      });
      dispatch(fetchChequeList());
    } catch (error) {
      modal.warning({
        title: error.message || "Delete failed",
      });
    }
  };

  const columns = [
    { title: "No.", dataIndex: "no", width: 60 },
    { title: "Customer/Supplier", dataIndex: "from_acc" },
    { title: "Voucher", dataIndex: "voucher_no" },
    { title: "Cheque Type", dataIndex: "cheque_type" },
    { title: "Cheque Number", dataIndex: "cheque_number" },
    {
      title: "Expected Bank",
      dataIndex: "expected_bank_name",
      render: (val, record) => {
        if (printMode || record.status !== "pending") {
          return val || "-";
        }
        return (
          <Select
            allowClear
            size="small"
            style={{ minWidth: 140 }}
            placeholder="Unassigned"
            loading={accountsLoading}
            value={record.expected_bank_acc_id || undefined}
            options={accounts.map((acc) => ({
              label: acc.acc_name,
              value: acc.acc_id,
            }))}
            onChange={(value) => handleExpectedBankChange(record, value || null)}
          />
        );
      },
    },
    {
      title: "Amount",
      dataIndex: "amount",
      render: (val) => format(Number(val || 0).toFixed(2)),
    },
    {
      title: "Invoice Date",
      dataIndex: "invoice_date",
      render: (v) => formatDateOnly(v),
    },
    {
      title: "Payable Date",
      dataIndex: "date",
      render: (v) => formatDateOnly(v),
    },
    {
      title: "Paid Date",
      dataIndex: "paid_date",
      render: (v) => (v ? formatDateOnly(v) : ""),
    },
    { title: "Status", dataIndex: "status" },
  !printMode && {
  title: "Actions",

  render: (_, record) => {
    const txLocked = isTxLocked(record?.date);

    return (
      <>
        <Button
          type="link"
          icon={<EyeOutlined />}
          onClick={() => onView(record)}
        >
          View
        </Button>

        {record.status === "pending" && (
          <>
            <Button
              type="link"
              disabled={txLocked}
              onClick={() => {
                if (txLocked) return;

                onUpdate(record);
              }}x











































































































            














            

















              
            >
              {txLocked
                ? `Locked until ${lockDateFormatted}`
                : "Update"}
            </Button>

            <Popconfirm
              title="Are you sure you want to delete this cheque?"
              okText="Yes, Delete"
              cancelText="Cancel"
              disabled={!(isAdminUser || canDelete) || txLocked}
              onConfirm={() => {
                if (txLocked) return;

                handleDelete(record);
              }}
            >
              <Button
                type="link"
                disabled={!(isAdminUser || canDelete) || txLocked}
                danger
                icon={<DeleteOutlined />}
              />
            </Popconfirm>
          </>
        )}
      </>
    );
  },
},
  ].filter(Boolean);

  return (
    <Table
      rowKey="id"
      dataSource={list}
      columns={columns}
      loading={loading}
      pagination={
        printMode
          ? false
          : {
              current: currentPage,
              pageSize: pageSize,
              total: list.length,
              showQuickJumper: true,
              showSizeChanger: true,
              pageSizeOptions: [10, 20, 50, 100],
              onChange: (page) => {
                setCurrentPage(page);
              },
              onShowSizeChange: (_, size) => {
                setPageSize(size);
                setCurrentPage(1);
              },
            }
      }
      scroll={{ x: "max-content" }}
      bordered
      size={printMode ? "small" : "middle"}
    />
  );
};

export default ChequesTable;
